import {Grid, Typography} from '@mui/material'
import React from 'react'

export default function NoData() {
    return <Grid container alignItems="center" justifyContent="center" p={2}>
        <Typography>Brak danych</Typography>
    </Grid>
};